module.exports = __webpack_public_path__ + "815688276676fb45dc0599e3daa57b0f.svg";